const MenuTypes = {
    INTEGRATION: {
        id: "integration",
        group: "settings_group",
        path: "integration",
        label: "Integration",
        tabs: [],
        implemented: true,
    },
    SENDER: {
        id: "sender",
        group: "settings_group",
        path: "sender",
        label: "sender",
        tabs: [],
        implemented: true,
    },
    SIGNATURE: {
        id: "signature",
        group: "settings_group",
        path: "signature",
        label: "signature",
        tabs: [],
        implemented: true,
    },
    INBOX: {
        id: "inbox",
        group: "settings_group",
        path: "inbox",
        label: "inbox",
        tabs: [],
        implemented: true,
    },
    MEDIA: {
        id: "medias",
        group: "settings_group",
        path: "medias",
        label: "medias",
        tabs: [],
        implemented: true,
    },
    VISIBILITY: {
        id: "visibility",
        group: "settings_group",
        path: "visibility",
        label: "Visibility",
        tabs: [],
        implemented: true,
    },
    CONTACTS: {
        id: "contacts",
        group: "contacts",
        path: "contacts",
        label: "All Contacts",
        tabs: [],
        implemented: true,
    },
};

Object.keys(MenuTypes).forEach((key) => {
    if (!MenuTypes[key].implemented) {
        delete MenuTypes[key];
    }
});

export default MenuTypes;
